import * as types from '../types';

const INITIAL_STATE = {
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GLOBAL_START_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.GLOBAL_STOP_LOADING:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
